import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

interface SessionExpiredDialogProps {
  onLogout: () => void;
  onClose: () => void;
}

const SessionExpiredDialog: React.FC<SessionExpiredDialogProps> = ({
  onLogout,
  onClose,
}) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-75 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <h2 className="text-xl font-bold text-center mb-4">
          Your session has expired
        </h2>
        <p className="text-center mb-6">Please log in again to continue.</p>
        <div className="flex justify-around">
          <button
            onClick={onLogout}
            className="bg-red-500 text-white px-4 py-2 rounded-lg"
          >
            Logout
          </button>
          <button
            onClick={onClose}
            className="bg-gray-500 text-white px-4 py-2 rounded-lg"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiredDialog;
